// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const shinx: PokeData = {
  "id": 403,
  "name": "shinx",
  "height": 5,
  "weight": 95,
  "base_experience": 53,
  "types": [
    PokeType.ELECTRIC
  ],
  "api_moves": [
    "tackle",
    "leer",
    "bite",
    "roar",
    "thunder-shock",
    "thunder-wave",
    "thunder",
    "quick-attack",
    "scary-face",
    "swagger",
    "spark",
    "crunch",
    "charge",
    "thunder-fang",
    "discharge",
    "volt-switch",
    "wild-charge",
    "baby-doll-eyes"
  ],
  "moves": [
    "tackle",
    "leer",
    "bite",
    "thunder-shock",
    "thunder",
    "quick-attack",
    "scary-face",
    "crunch",
    "thunder-fang",
    "volt-switch",
    "wild-charge",
    "electric-terrain",
    "electric-wrath"
  ],
  "evolution_chain": {
    "id": 209,
    "item": null,
    "species": [
      {
        "name": "shinx",
        "order": 433,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "luxio",
        "order": 434,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": 403,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 15,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "luxray",
        "order": 435,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": 404,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 39.5,
    "speed": 45,
    "ability_power": 65
  },
  "stat_changes": [],
  "catch_rate": 235,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
